import AccordionItemUI from '@app/components/ui/Accordion/AccordionItem';
import { Button } from '@ui';
import React, { FC, ReactNode } from 'react';
import { useGetUserInfoQuery } from '@app/store/api/get-user-info.api';
import useTranslation from '@app/hooks/use-translation';
import {
  StatisticWidgetObjectFromBulk,
  StatisticWidgetFullInfoType,
  StatisticWidgetsBulkRequestType,
} from '@app/interfaces/qm-module/qm-statistic/qm-statistic.type';

type WidgetWrapperPropsType = {
  children: ReactNode;
  handleClickWidgetAccordion(id: string): void;
  handleOpenTap(key: 'monitoring' | 'teams' | 'operators', name: string): void;
  openedWidgets: string[];
  widgetData: StatisticWidgetObjectFromBulk;
  setFullWidget: React.Dispatch<React.SetStateAction<StatisticWidgetFullInfoType | undefined>>;
  fullWidget: StatisticWidgetFullInfoType | undefined;
  handleOpenFullWidget: (filter: Partial<StatisticWidgetsBulkRequestType>) => void;
  setOpenedWidgets: React.Dispatch<React.SetStateAction<string[]>>;
  widgetsFilterBlock: Partial<StatisticWidgetsBulkRequestType>;
};

const WidgetWrapper: FC<WidgetWrapperPropsType> = (props) => {
  const {
    children,
    handleClickWidgetAccordion,
    handleOpenTap,
    openedWidgets,
    fullWidget,
    handleOpenFullWidget,
    setFullWidget,
    setOpenedWidgets,
    widgetData,
    widgetsFilterBlock,
  } = props;
  const { data: userInfo } = useGetUserInfoQuery();
  const { t } = useTranslation('pages.qmManage.statistic.widget');

  return (
    <AccordionItemUI
      classname="!h-[50px]"
      variant="filled"
      title={
        <div className="p-6 flex items-center justify-between w-full relative ">
          <div>{widgetData.mfs.name}</div>
          <div>
            <Button
              onClick={
                fullWidget
                  ? () => setFullWidget(undefined)
                  : () => {
                      const id = widgetData.mfs.id;
                      handleOpenFullWidget(widgetsFilterBlock);
                      setOpenedWidgets((prevItems) => {
                        const index = prevItems.indexOf(id);
                        if (index === -1) {
                          return [...prevItems, id];
                        } else {
                          return prevItems;
                        }
                      });
                    }
              }
              fill="linked"
              label={
                fullWidget ? t('accordion_label_button_close') : t('accordion_label_button_more')
              }
              variant={fullWidget ? 'danger' : 'primary'}
              className="danger"
            />
            <Button
              onClick={() => handleOpenTap('monitoring', widgetData.mfs.name)}
              className="danger"
              fill="linked"
              label={t('accordion_label_button_monitoring')}
            />
            {(userInfo?.qm_role === 'controller' || userInfo?.qm_role === 'manager') && (
              <Button
                onClick={() => handleOpenTap('teams', `${widgetData.mfs.name}`)}
                className="danger"
                fill="linked"
                label={t('accordion_label_button_teams_details')}
              />
            )}
            <Button
              onClick={() => handleOpenTap('operators', widgetData.mfs.name)}
              className="danger"
              fill="linked"
              label={t('accordion_label_button_operator_details')}
            />
          </div>
        </div>
      }
      active={openedWidgets.includes(widgetData.mfs.id)}
      clickBtnChild={({ id }) => handleClickWidgetAccordion(id)}
      id={widgetData.mfs.id}
      key={widgetData.mfs.id}
    >
      {children}
    </AccordionItemUI>
  );
};

export default WidgetWrapper;
